import { Component, OnInit } from '@angular/core';
import { Sidebar2SubpanelStateService } from './../../sidebar2-subpanel-state.service';

@Component({
    selector: 'app-sidebar2-clients-sub-menu',
    templateUrl: './sidebar2-clients-sub-menu.component.html',
    standalone: false,
})
export class Sidebar2ClientsSubMenuComponent implements OnInit {
    statuses: any = [];
    constructor(private subpanelService: Sidebar2SubpanelStateService) {}

    ngOnInit() {
        this.subpanelService.getCustomerPromise().then((res) => {
            this.statuses = res;
        });
    }
}
